<template lang="pug">
  .cus-radio
    div(v-if="!value" @click="agreeToggle")
      img.rule-word-img(src="https://m.hellobike.com/resource/helloyun/08345/37EqW_CTt-.png")
    div(v-else @click="agreeToggle")
      img.rule-word-img(src="https://m.hellobike.com/resource/helloyun/08345/JJ8LaMe1nV.png")
</template>

<script>
export default {
  name: 'CusRadio',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    agreeToggle() {
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="less">
.rule-word-img {
  display: block;
  width: 0.12rem;
  height: 0.12rem;
  margin-right: 0.04rem;
}

.canClick {
  color: #0081f1;
}
</style>
